export type SetupChecklistStateCompany = {
  sitemap: boolean;
  urlParameters: boolean;
  ignoredUrls: boolean;
  cacheExpiration: boolean;
  notFoundChecker: boolean;
};

export const INITIAL_STATE_SETUP_CHECKLIST_COMPANY: SetupChecklistStateCompany = {
  sitemap: false,
  urlParameters: false,
  ignoredUrls: false,
  cacheExpiration: false,
  notFoundChecker: false,
};

export const SETUP_CHECKLIST_KEYS = {
  sitemap: 'sitemap',
  urlParameters: 'url-parameters',
  ignoredUrls: 'ignored-urls',
  cacheExpiration: 'cache-expiration',
  notFoundChecker: 'not-found-checker',
} as const;

export type SetupChecklistKey = typeof SETUP_CHECKLIST_KEYS[keyof typeof SETUP_CHECKLIST_KEYS];

export const STATE_TO_KEY_MAP: Record<keyof SetupChecklistStateCompany, SetupChecklistKey> = {
  sitemap: SETUP_CHECKLIST_KEYS.sitemap,
  urlParameters: SETUP_CHECKLIST_KEYS.urlParameters,
  ignoredUrls: SETUP_CHECKLIST_KEYS.ignoredUrls,
  cacheExpiration: SETUP_CHECKLIST_KEYS.cacheExpiration,
  notFoundChecker: SETUP_CHECKLIST_KEYS.notFoundChecker,
};
